var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import "animate.css/source/_vars.css";
import "animate.css/source/_base.css";
import "animate.css/source/bouncing_entrances/bounceIn.css";
import "animate.css/source/flippers/flipOutY.css";
var TIMEOUT_MS = 3500;
var SHORT_TIMEOUT_MS = 1000;
var timeout;
var timeoutExpired = false;
var preventAutoHiding = false;
var observer;
var element;
export default function initHerdInstinct(el) {
    if (!el) {
        return;
    }
    element = el;
    if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
            var e_1, _a;
            try {
                for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                    var entry = entries_1_1.value;
                    if (entry.isIntersecting) {
                        hideOnTimeout();
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        observer.observe(document.querySelector('.prod-cover__bottom'));
    }
    element.querySelector('.prod-msg__btn').addEventListener('click', hide);
    element.addEventListener('mouseenter', function () { return preventAutoHiding = true; });
    element.addEventListener('mouseleave', function () {
        preventAutoHiding = false;
        hideOnTimeout();
    });
}
function resetTimeout() {
    if (timeout) {
        clearTimeout(timeout);
        timeout = undefined;
    }
}
function hide() {
    resetTimeout();
    element.style.animationName = '';
    element.classList.add('flipOutY', 'animated', 'faster');
    element.addEventListener('animationend', function () {
        if (element.parentElement) {
            element.parentElement.remove();
        }
        observer.disconnect();
    });
}
function hideOnTimeout() {
    timeout = setTimeout(function () {
        timeoutExpired = true;
        if (!preventAutoHiding) {
            hide();
        }
    }, timeoutExpired ? SHORT_TIMEOUT_MS : TIMEOUT_MS);
}
